import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Input, InputPrefix } from "@tql/ui-components-react/kendo/inputs";
import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	check,
	searchSm,
	send_01,
	xClose,
} from "@tql/ui-components-react/untitled/icons";

import { PostalCodeSearch } from "~/shared/components/fields/postal-code-search.tsx";
import type { ZipCode } from "~/shared/schemas/location-state-schema.ts";

export const CheckCallForm = ({
	message,
	onMessageChange,
	postalCodeValue,
	postalResetKey,
	onPostalSelectionChange,
	isEditing,
	isSaving,
	onSubmit,
	onCancel,
	locationError,
	messageError,
}: {
	message: string;
	onMessageChange: (value: string) => void;
	postalCodeValue: string;
	postalResetKey: number;
	onPostalSelectionChange: (zipCode: ZipCode | null) => void;
	isEditing: boolean;
	isSaving: boolean;
	onSubmit: () => void;
	onCancel: () => void;
	locationError?: string;
	messageError?: string;
}) => (
	<div className={"tracking-input-container"}>
		<div className={"tracking-input-fields"}>
			<div>
				<PostalCodeSearch
					key={`postal-${postalResetKey}`}
					disabled={isSaving}
					onSelectionChange={onPostalSelectionChange}
					placeholder={"Enter City, State, Postal Code"}
					prefix={() => (
						<InputPrefix>
							<SvgIcon icon={searchSm} />
						</InputPrefix>
					)}
					value={postalCodeValue}
				/>
				{locationError ? (
					<div className={"k-form-error"}>{locationError}</div>
				) : null}
			</div>
			<div>
				<Input
					disabled={isSaving}
					onChange={(e) => onMessageChange(e.target.value as string)}
					placeholder={"Type a Message"}
					type={"text"}
					value={message}
				/>
				{messageError ? (
					<div className={"k-form-error"}>{messageError}</div>
				) : null}
			</div>
		</div>
		{isEditing ? (
			<div className={"remark-edit-actions"}>
				<Button disabled={isSaving} onClick={onCancel} variant={"tertiary"}>
					<SvgIcon icon={xClose} size={"large"} />
				</Button>{" "}
				<Button disabled={isSaving} onClick={onSubmit} variant={"tertiary"}>
					<SvgIcon icon={check} size={"large"} />
				</Button>
			</div>
		) : (
			<Button disabled={isSaving} onClick={onSubmit}>
				<SvgIcon icon={send_01} size={"large"} />
			</Button>
		)}
	</div>
);
